import FooterDefault from '@/app/_components/shared/footer/footer-default';
import FooterSimple from '@/app/_components/shared/footer/footer-simple';
import type {FooterComponentProps} from './footer.types';

const footerVariants = {
    simple: FooterSimple,
    default: FooterDefault,
} as const;

export default function FooterComponent(props: FooterComponentProps) {
    const {layout = 'default'} = props;

    const Footer = footerVariants[layout];

    return <Footer {...props} />;
}
